import store from '../vuex'
import bus from '@utils/bus'

export default (to) => {
  if (store.getters.showSidebar) {
    store.dispatch('toggleSidebar')
  }
  if (typeof document !== 'undefined') {
    document.title = to.meta.breadcrumb.name + ' - Sou URCAMP'
  }
  setTimeout(() => {
    if (store.getters.isLoading) {
      bus.$emit('hide-loader')
    }
  }, 2000)
}



// WEBPACK FOOTER //
// ./src/router/afterEach.js